var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main flex-start-center"},_vm._l((_vm.stepList),function(item,index){return _c('div',{key:item,class:[
      'flex-start-center',
      index === _vm.current ? 'current' : '',
      index < _vm.current ? 'done' : ''
    ]},[_c('div',{staticClass:"circle flex-center-center"},[(index >= _vm.current)?_c('span',[_vm._v(_vm._s(index + 1))]):_c('span',{staticClass:"iconfont-ai icon"},[_vm._v("")])]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(item))]),(index !== _vm.stepList.length - 1)?_c('div',{staticClass:"line"}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }